<div class="not-found-container">
    <div class="content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
        <button class="home-button" (click)="goToHome()">Go to Homepage</button>
    </div>
</div>